import { render } from "./AlarmmessagesForPlants.vue?vue&type=template&id=80303f4a"
import script from "./AlarmmessagesForPlants.vue?vue&type=script&lang=js"
export * from "./AlarmmessagesForPlants.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__